<div class="banner">
  <div class="middle-text">
    <slot name="link_one">
      Already you are involved in Medigap? If Yes,
    </slot>
  </div>
  <div>
    <button class='button-class' mat-raised-button (click)="goToEnrollFlow()">
      <slot name="link_two">
        Click here to know more on Whole Health Balance
      </slot>
    </button>
  </div>
</div>